import store from '@/store'
// 默认模板
import defaultLayout from '@/layout/default.vue' 
// 判断是否是移动端
store.dispatch('pageInfo/isMobile')
let isPc = !store.getters.isMobile

const BASICPATH = 'views'

// 获取页面地址
export function getPage(path) {
  const type = isPc ? 'pc' : 'h5'
  return `${BASICPATH}/${type}/${path}`
}

// 获取页面资源
export function requirePage(data, resolve) {
  let index = ''
  if (typeof data === 'object') {
    const { pc, h5 } = data
    if (isPc) {
      index = pc
    } else {
      index = h5
    }
  }
  if (index) {
    return require(['@/'+ getPage(index)], resolve)
  }
  return null
}

// 是否需要layout
export function initLayout(pcLayout, h5Layout) {
  const pcComp = pcLayout
  const h5Comp = h5Layout
  return function ({ pc = false, h5 = false } = {}) {
    if (isPc && pc) {
      return pcComp
    }
    if (!isPc && h5) {
      return h5Comp
    }
    return defaultLayout
  }
}


// WEBPACK FOOTER //
// ./src/utils/router.js